export default "__VITE_ASSET__9b0eb007__"